import store from "../../store";
import SettingsAPI from "./SettingsAPI";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

/* ========== INITIALIZATION POINTS ========== */
const apps = {
  googleCalendar: {
    connect: getAuthUrl, // getAuthUrl delivers the URL to user. connectGoogleCalendar gets triggered after the user has successfuly signed in.
    disconnect: disconnectGoogleCalendar,
  },
};
export async function initConnect(app) {
  await apps[app]["connect"]();
}

export async function initDisconnect(app) {
  await apps[app]["disconnect"]();
}

/* ========== GOOGLE CALENDAR ========== */

async function getAuthUrl() {
  const UID = AuthStore.user._id;

  /* Get Google Calendar Authorizaton URL */
  const result = await SettingsAPI.getGoogleCalAuthURL(UID);

  if (!result.authURL || !result.success) {
    if (result.disconnected === false) {
      // ROBERT: Report this specific error to front-end.
      console.error('Please try clicking "Connect" again in a few moments.');
    }

    // Report this generic error to front-end.
    console.error("There was some trouble contacting Google to sign you in.");
  }

  /* Re-direct user to authorization URL */
  window.location.href = result.authURL;
}

/* Exported Google Calendar functions */
export async function connectGoogleCalendar(authCode) {
  console.log("Connecting Google Calendar using authorization code...");
  const UID = AuthStore.user._id;

  const connectResult = await SettingsAPI.connectGoogleCalAfterAuthURL(UID, authCode);
  console.log("@connectGoogleCalendar success status: ", connectResult.success);

  /* If authorization is successful, set Google Cal auth state to true */
  if (connectResult) {
    const data = {
      integration: "googleCalendar",
      connected: true,
    };
    /* Set integration data in Vuex (Vue central storage)*/
    store.dispatch("integrations/setIntegrationConnectedState", data);
  } else {
    console.log("Something went wrong when authorizing Google Calendar Access: ", connectResult);
  }
}

export async function disconnectGoogleCalendar() {
  // const data = {
  //   integration: "googleCalendar",
  //   connected: false,
  // };

  /* Set integration data in Vuex (Vue central storage)*/
  // store.dispatch("integrations/setIntegrationConnectedState", data);

  /* Trigger back-end flow. This flow deletes existing events user has booked and removes tokens from database */

  const UID = AuthStore.user._id;
  const disconnectResult = await SettingsAPI.disconnectGoogleCal(UID);
  console.log("@disconnectGoogleCalendar success status: ", disconnectResult.success);

  // await SettingsAPI.updateUserIntegrationsData(userID, data);
}
